module.exports = __webpack_public_path__ + "img/game_pc_en.d79b8ea9.png";